import React from 'react';

import CategoryChecklist from '../CategoryChecklist/CategoryChecklist';

const RenderInput = ({
  rowValues,
  handleRowValueChange,
  column,
  row,
  categories,
}) => {
  const { inputType, key, type } = column;
  const currentValue = rowValues[key];
  switch (inputType) {
    case 'input': {
      return (
        <input
          onChange={(e) => handleRowValueChange(e.target.name, e.target.value)}
          value={currentValue || ''}
          name={key}
          type={type}
          className="campaign-table-input"
          min={0}
          maxLength={key === 'sku' ? 19 : undefined}
        />
      );
    }
    case 'dropdownBoolean': {
      return (
        <div className="select-container">
          <select
            value={currentValue}
            name={key}
            onChange={(e) =>
              handleRowValueChange(e.target.name, e.target.value)
            }
            className="campaign-table-input"
          >
            <option value="true">true</option>
            <option value="false">false</option>
          </select>
        </div>
      );
    }
    case 'categoryChecklist': {
      return (
        <CategoryChecklist
          handleRowValueChange={handleRowValueChange}
          selectedCategoryIds={currentValue || []}
          categories={categories}
        />
      );
    }
    default: {
      return (
        <div className="row">
          <p className="row-text">{row[key]}</p>
        </div>
      );
    }
  }
};

export default RenderInput;
